// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';

import '../src/shared/klaro_config';
window.klaro = require('../src/application/klaro-no-css');

require("turbolinks").start()
require("@rails/activestorage").start()
require('jquery')

import "normalize.css/normalize.css";
import "../src/klaro.scss"

// Support component names relative to this directory:
var componentRequireContext = require.context("components", true);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);

import React from 'react'
import ReactDOM from 'react-dom'
import * as Sentry from '@sentry/browser';
import MainRouter from "components/main_router"
import { ToastContextProvider } from "components/contexts/toast_context.js";
import { CurrentUserContextProvider } from "components/contexts/current_user_context.js"
import { ModalContextProvider } from "components/contexts/modal_context.js";
import initFontAwesome from "../src/application/initFontAwesome";
initFontAwesome();

if(window.SENTRY_DSN) {
  Sentry.init({dsn: window.SENTRY_DSN});
}


document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(
    <ToastContextProvider>
      <CurrentUserContextProvider>
        <ModalContextProvider>
          <MainRouter />
        </ModalContextProvider>
      </CurrentUserContextProvider>
    </ToastContextProvider>,
    document.body.appendChild(document.createElement('div')),
  )
})
